module.exports = __webpack_public_path__ + "fonts/msyh.4f6a5917.ttf";